<template>
  <div>
    <el-radio-group v-model="path"  size="medium" @change="tabPath">
      <el-radio-button label="/recipeStatistics/anomaly/anomaly">异常类型</el-radio-button>
      <el-radio-button label="/recipeStatistics/anomaly/operator">代理商设备异常总数</el-radio-button>
      <el-radio-button label="/recipeStatistics/anomaly/abnormalSum">设备类型异常总数</el-radio-button>
      <el-radio-button label="/recipeStatistics/anomaly/evaluationType">异常评价分布</el-radio-button>
<!--      <el-radio-button label="/recipeStatistics/anomaly/maintenance">保养类型</el-radio-button>-->
      <el-radio-button label="/recipeStatistics/anomaly/devicesSum">代理商设备保养总数</el-radio-button>
      <el-radio-button label="/recipeStatistics/anomaly/maintenanceEvaluation">保养评价分布</el-radio-button>
    </el-radio-group>
    <div style="margin-top: 20px">
      <keep-alive>
        <router-view v-if='$route.meta.keepAlive'></router-view>
      </keep-alive>
      <router-view v-if='!$route.meta.keepAlive'></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "anomaly",
  data() {
    return {
      path: "/recipeStatistics/anomaly/anomaly"
    }
  },
  watch: {
    $route: {
      handler: function(val, oldVal){
        this.path=this.$route.path
      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.path=this.$route.path
  },
  component: {
    //someComponent
  },
  methods: {
    //
    tabPath(){
      this.$router.push(this.path)
    }
  },
  mounted() {
    //
  }
}
</script>

<style lang="scss" scoped>
.index {

}
</style>